import React, { useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";

const TopBanner = ({ setBannerHeight }) => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const updateHeight = () => {
      if (bannerRef.current) {
        setBannerHeight(bannerRef.current.offsetHeight);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [setBannerHeight]);

    return (
        <div
            ref={bannerRef}
            className="w-full fixed top-0 z-[9999] h-[45px] md:h-[50px] 
            border-b border-[#718929]
            bg-gradient-to-r from-[#1F1F1F] via-[#2a2a2a] to-[#1F1F1F]"
        >
            <Marquee
            speed={50}
            gradient={false}
            pauseOnHover={true}
            className="h-full flex items-center"
            >
            <span className="mx-8 lg:mx-14 text-[#F0FFC5] font-medium text-sm md:text-base">
                We are now delivering professional car inspection services in Bangalore and Mysore.
            </span>

            <span className="mx-8 lg:mx-14 text-[#ADD143] font-semibold text-sm md:text-base">
                Book your inspection today
            </span>

            <span className="mx-8 lg:mx-14 text-[#F0FFC5] font-medium text-sm md:text-base">
                We are now delivering professional car inspection services in Bangalore and Mysore.
            </span>

            <span className="mx-8 lg:mx-14 text-[#ADD143] font-semibold text-sm md:text-base">
                Book your inspection today
            </span>
            </Marquee>
        </div>
    );
};

export default TopBanner;
